import { Spinner } from "@pracownik/ui";

/** Full-viewport loading state used for route-level suspense and auth checks. */
export function PageSpinner() {
  return (
    <div className="flex min-h-dvh items-center justify-center" role="status" aria-live="polite">
      <Spinner className="size-6 text-text-tertiary" />
    </div>
  );
}
